import React, { useCallback, ReactElement } from 'react';
import Card from '../../../../components/card/card.component';
import Button from '../../../../components/button/button.component';
import ModalButtonBlock from '../../../../components/modal-button-block/modal-button-block.component';
import ModalLayout from '../../../../components/modal-layout/modal-layout.component';

const FiltersModal: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isOpen,
    isFilterApplyDisabled,
    currentFilters,
    filterComponent,
    onCloseModal,
    onApplyFilters,
    onResetFilters,
  } = props;

  const closeModal: Function = useCallback((): void => {
    if (onResetFilters) {
      onResetFilters();
    }

    if (onCloseModal) {
      onCloseModal();
    }
  }, [currentFilters]);

  const applyFilters: MouseEventHandlerFunction = useCallback((): void => {
    if (onApplyFilters && !isFilterApplyDisabled) {
      onApplyFilters();
    }

    if (onCloseModal) {
      onCloseModal();
    }
  }, [currentFilters, isFilterApplyDisabled]);

  return (
    <ModalLayout isOpen={isOpen} title="Filters" onCloseModal={closeModal}>
      <Card isContainer>
        {filterComponent}
      </Card>
      <ModalButtonBlock>
        <Button isActive isDisabled={isFilterApplyDisabled} onClick={applyFilters}>
          Apply
        </Button>
      </ModalButtonBlock>
    </ModalLayout>
  );
});

export default FiltersModal;
